// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__28oyw","inputWrap":"CustomTip_inputWrap__2plOV"};